
const buttons = document.querySelectorAll('.ygseo-product-card__add-to-cart');
const minicart = document.querySelector("mini-cart");
function addToCartDrawer(button) {
    const variantId = parseInt(button.parentNode.querySelector('.product-variant-id').value);
    const originalText = button.innerHTML;
    
    button.innerHTML = 'Adding...';
    button.disabled = true;

    fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
            items:[{
                id: variantId,
                quantity: 1
            }]
        })
    })
    .then(async response => {
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        // 触发主题的购物车刷新
        minicart.updateSectionContents().finally(()=>{
            minicart.open()
        })
    })
    .catch(error => {
        console.error('[YGSEO Product Card] Add to cart error:', error);
        document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
            detail: { 
                message: 'Adding cart failed, please try again later.',
                error: error.message
            }
        }));
    })
    .finally(() => {
        button.innerHTML = originalText;
        button.disabled = false;
    });
}

buttons.forEach(button => {
    button.addEventListener('click',()=>addToCartDrawer(button))
})